module.exports = "/packs/images/pages/venues/library_tablet~7549e4280a496a481cee936647151ea8.jpg";